import { PoweredBy } from 'components/poweredBy/poweredBy.module';
import { ReplyInput } from 'components/replyInputArea/replyInput.module';
import { ScrollToBottom } from 'components/scrollToBottom/scrollToBottom.module';
import { TypingIndicatorModule } from 'components/typingIndicator/typingIndicator.module';
import { CHAT_BG_TYPE } from 'consts/enum';
import { setCustomTagHTML } from 'helpers/helpers';
import { ENGT_CHAT } from 'js/bot.model';
import { resetUnreadMessage } from 'js/conversation';

import { chatScreen } from './chatScreen.model';
import { ChatScreenTemplate } from './chatScreen.template';

export default class ChatScreen {
	constructor(props) {
		this.initData(props);
		this.initWrapper();
		this.initComponents();
		this.initEvents();
	}

	reRenderChatScreen = () => {
		resetUnreadMessage();
	};

	initData(props) {
		const chatBgType = ENGT_CHAT.get('config.background_option');
		const wallpaperUrl = ENGT_CHAT.get('config.wallpaper_image_url');
		const topColor = ENGT_CHAT.get('config.top_stop_color') || '#FFFFFF';
		const bottomColor = ENGT_CHAT.get('config.bottom_stop_color') || '#F1F1F1';
		const midColor = ENGT_CHAT.get('config.mid_stop_color') || '#FFFFFF';
		let style = '';
		let autoSuggStyle = '';
		let videoBg = '';

		if (chatBgType === CHAT_BG_TYPE.IMAGE && wallpaperUrl) {
			style = `background-image: url(${wallpaperUrl}); background-size:cover; background-position: center top;`;
			autoSuggStyle = 'background-color: #ddd; border: none;';
		} else if (chatBgType === CHAT_BG_TYPE.GRADIENT || chatBgType === CHAT_BG_TYPE.SOLID) {
			style = `background-image: linear-gradient(to top,${bottomColor},${midColor},${topColor});`;
			autoSuggStyle = `background-color: ${topColor}; border: none;`;
		} else if (chatBgType === CHAT_BG_TYPE.VIDEO && wallpaperUrl) {
			/* html */
			videoBg = `
				<video autoplay muted loop class="engt-background-video" data-object-fit>
					<source src="${wallpaperUrl}" type="video/mp4">
				</video>`;
		}

		this.data = chatScreen;
		this.setter({
			...props,
			bgStyle: style,
			videoBg: videoBg || '',
			botMode: ENGT_CHAT.get('config.bot_mode'),
			autoSuggStyle,
		});
		ENGT_CHAT.set('quotedMsgDetails', null);
	}

	initWrapper() {
		const wrapper = document.createElement('div');
		wrapper.className = 'engt-chat-screen';
		wrapper.id = 'engtChatScreen';
		if (ENGT_CHAT.get('config.isFadingMessagesEnabled')) {
			wrapper.classList.add('engt-chat-animate');
		}
		wrapper.innerHTML = ChatScreenTemplate(this.data);

		this.html = wrapper;
	}

	initComponents() {
		const replyInputArea = new ReplyInput().render();
		const typingIndicator = new TypingIndicatorModule({ id: 'engt-typing-indicator' }).render();
		const poweredBy = new PoweredBy().render();
		const scrollDownBtn = new ScrollToBottom({
			id: 'engtChatContent',
		}).render();

		setCustomTagHTML(this.html.querySelector('scroll-to-bottom'), scrollDownBtn);
		setCustomTagHTML(this.html.querySelector('input-area'), replyInputArea);
		setCustomTagHTML(this.html.querySelector('typing-indicator'), typingIndicator);
		setCustomTagHTML(this.html.querySelector('powered-by'), poweredBy);
	}

	initEvents() {
		ENGT_CHAT.set('reRenderChatScreen', this.reRenderChatScreen);
	}

	setter(propData) {
		this.data = {
			...this.data,
			...propData,
		};
	}

	render() {
		return this.html;
	}
}
